// VtsGob — the Vehicle Transport Station: the vehicle builder (a MobileUnitBuilderGob
// wrapper with the VTS upgrade flags). game/VTS.cpp (all 80 lines; the build form is UI).

import type { SimContext } from '../context.ts';
import { MobileUnitBuilderGob } from './builder.ts';
import {
  MobileUnitBuilderConsts,
  InitBuilderConstsClass,
  kfUntcMobileUnitBuilder,
} from './unitconsts.ts';
import { kgtVehicleTransportStation } from './gobtypes.ts';
import { kutVehicleTransportStation } from '../player/side.ts';
import { kumReactor, kumVehicles } from '../player/masks.ts';
import { kfUpgradeVts, kfUpgradeVtsInProgress } from '../sm/message.ts';
import { registerGobType } from './factory.ts';
import type { IniReader } from '../data/ini.ts';
import {
  ksfxVehicleTransportStationAbortManufacture,
  ksfxVehicleTransportStationManufacture,
  ksfxVehicleTransportStationVehicleReady,
  ksfxVehicleTransportStationAbortRepair,
  ksfxVehicleTransportStationDamaged,
  ksfxVehicleTransportStationDestroyed,
  ksfxVehicleTransportStationRepair,
  ksfxVehicleTransportStationSelect,
} from '../data/soundeffects.ts';

// game/VTS.cpp:5-30
export function InitVtsClass(ctx: SimContext, pini: IniReader): boolean {
  const c = new MobileUnitBuilderConsts().bind(ctx);
  c.gt = kgtVehicleTransportStation;
  c.ut = kutVehicleTransportStation;
  c.umPrerequisites = kumReactor;
  c.umCanBuild = kumVehicles;
  c.wf |= kfUntcMobileUnitBuilder;
  c.fUpgrade = kfUpgradeVts;
  c.fUpgradeInProgress = kfUpgradeVtsInProgress;
  // Sound effects (VTS.cpp:37-44)
  c.sfxUnitBuildAbort = ksfxVehicleTransportStationAbortManufacture;
  c.sfxUnitBuild = ksfxVehicleTransportStationManufacture;
  c.sfxUnitReady = ksfxVehicleTransportStationVehicleReady;
  c.sfxAbortRepair = ksfxVehicleTransportStationAbortRepair;
  c.sfxDamaged = ksfxVehicleTransportStationDamaged;
  c.sfxDestroyed = ksfxVehicleTransportStationDestroyed;
  c.sfxRepair = ksfxVehicleTransportStationRepair;
  c.sfxSelect = ksfxVehicleTransportStationSelect;
  return InitBuilderConstsClass(ctx, c, pini);
}

export class VtsGob extends MobileUnitBuilderGob {
  constructor(ctx: SimContext) {
    // VTS.cpp:37-39
    super(ctx, ctx.unitConsts[kutVehicleTransportStation] as MobileUnitBuilderConsts);
  }
}

// self-register (see factory.ts)
registerGobType(kgtVehicleTransportStation, (ctx) => new VtsGob(ctx));
